import styled from 'styled-components';

export const MapMarkerContainer = styled.div`
  .mark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &:hover {
      z-index: 2;
    }
    &-content {
      z-index: 1;
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translate(-50%, -9px);
      cursor: default;
      background: ${({ theme }) => theme.colors.background};
      border-radius: 6px;
      &__arrow {
        width: 10px;
        height: 10px;
        background: ${({ theme }) => theme.colors.background};
        position: absolute;
        bottom: -3px;
        left: calc(50% - 4px);
        transform: translate(-50%);
        transform: rotate(45deg);
      }
    }
  }

  .coverage-map-marker {
    font-size: 1.5rem;
    border-radius: 5px;
    padding: 3px;
    color: ${({ theme }) => theme.colors.text};
    box-shadow: ${({ theme }) => theme.shapes.boxShadow};

    &-static {
      background: ${({ theme }) => theme.colors.green};
    }
    &-click {
      background: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const MapMarkerContent = styled.div``;
